import Vue from 'vue';
import Router from 'vue-router';
import {routesNames, routesPaths} from "../interfaces/routeInterface";

const {availableLocalesNames} = require('../../config/localization');
const regexSupportedLocales = availableLocalesNames.map(locale => locale.toLowerCase()).join('|');

Vue.use(Router);


export function createRouter(store) {
    let routes = [
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_RESET_PASSWORD]}`,
            component: Vue.options.components.TheResetPassword,
            name: routesNames.USER_RESET_PASSWORD
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_ACCOUNT]}`,
            component: Vue.options.components.TheAccount,
            name: routesNames.USER_ACCOUNT,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_COMPLETE_SIGNUP]}`,
            component: Vue.options.components.CompleteSignup,
            name: routesNames.USER_COMPLETE_SIGNUP,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_BONUSES]}`,
            component: Vue.options.components.TheBonuses,
            name: routesNames.USER_BONUSES,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_TRANSACTION_HISTORY]}`,
            component: Vue.options.components.TransactionHistory,
            name: routesNames.USER_TRANSACTION_HISTORY,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_VIP_POINTS]}`,
            component: Vue.options.components.TheVipPoints,
            name: routesNames.USER_VIP_POINTS,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_VERIFY_IDENTITY]}`,
            component: Vue.options.components.TheVerifyIdentity,
            name: routesNames.USER_VERIFY_IDENTITY,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_LIMITS]}`,
            component: Vue.options.components.TheLimits,
            name: routesNames.USER_LIMITS,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_REWARDS]}`,
            component: Vue.options.components.TheRewards,
            name: routesNames.USER_REWARDS,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_TOURNAMENTS]}`,
            component: Vue.options.components.TheTournaments,
            name: routesNames.USER_TOURNAMENTS,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_SELF_EXCLUSION]}`,
            component: Vue.options.components.SelfExclusion,
            name: routesNames.USER_SELF_EXCLUSION,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.USER_TWO_FACTOR_AUTH]}`,
            component: Vue.options.components.TwoFactorAuth,
            name: routesNames.USER_TWO_FACTOR_AUTH,
            beforeEnter: redirectIfNoUser
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.SERVICE_UNAVAILABLE]}`,
            component: Vue.options.components.TheServiceUnavailable,
            name: routesNames.SERVICE_UNAVAILABLE
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.PAGE_NOT_FOUND]}`,
            component: Vue.options.components.ThePageNotFound,
            name: routesNames.PAGE_NOT_FOUND
        },
        {
            path: `/:locale(${regexSupportedLocales})?${routesPaths[routesNames.PAGE_HAS_NOT_TRANSLATION]}`,
            component: Vue.options.components.NoTranslation,
            name: routesNames.PAGE_HAS_NOT_TRANSLATION
        },
    ];

    store.state.routes.forEach(route => {
        routes.push({
            path: `/:locale(${regexSupportedLocales})?${route.path}`,
            component: Vue.options.components.RouteRootComponent,
            meta: {
                backUrlTemplate: route.backUrlTemplate,
            },
            name: route.frontName,
            beforeEnter: checkDynamicRouteUser,
        })
    })

    routes.push({
        path: '*',
        component: Vue.options.components.ThePageNotFound,
    });

    return new Router({
        mode: 'history',
        fallback: false,
        scrollBehavior: () => {
            const body = document.querySelector('body');
            body && body.scroll({top: 0, behavior: 'smooth'});

            const app = document.querySelector('#app');
            app && app.scrollIntoView({behavior: 'smooth'});

            const doc = document.documentElement;
            doc && doc.scroll({top: 0, behavior: 'smooth'});
        },
        routes
    });

    function redirectIfNoUser(to, from, next) {
        // redirect to main if user already fetched, and it's null
        if (!store.state.user) {
            let locale = to.params.locale;
            let redirectPath = locale ? `/${locale}` : '/';

            next(redirectPath);
        } else {
            next();
        }
    }

    function checkDynamicRouteUser(to, from, next) {
        if ((to.params.slug === 'favorite-games' || to.params.slug === 'recently-played-games') && !store.state.user) {
            let locale = to.params.locale;
            let redirectPath = locale ? `/${locale}` : '/';

            next(redirectPath);
        } else {
            next();
        }
    }
}
